import React from 'react';
import styled from 'styled-components';

const StatWrapper = styled.div`
	@media screen and (min-width: 640px) {
		display: ${(props) => (props.flex ? 'flex' : 'inline-block')};
		align-items: flex-end;
		max-width: ${(props) => (props.flex ? '800px' : '500px')};
		margin: auto;
	}
`;

const NumberWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: ${(props) => (props.flex ? '50px' : '0')};
`;

const Number = styled.h1`
	font-size: 85px;
	color: #669d9e;

	@media screen and (min-width: 650px) {
		font-size: 140px;
	}
`;

const NumberUnit = styled.h2`
	color: #669d9e;
	line-height: 55px;
`;

const Description = styled.div`
	margin-top: 20px;
	@media screen and (min-width: 640px) {
		margin-top: 40px;
	}
`;

const ImpactStatistic = ({number, unit, description, flex}) => {
	return (
		<StatWrapper flex={flex}>
			<NumberWrapper flex={flex}>
				<Number>{number}</Number>
				<NumberUnit>{unit}</NumberUnit>
			</NumberWrapper>
			<Description>
				<p style={{whiteSpace: 'pre-line'}}>{description}</p>
			</Description>
		</StatWrapper>
	);
};

export default ImpactStatistic;
